import { useRef } from "react";
import LinkWrapper from "../../../../global/components/LinkWrapper/LinkWrapper";
import useOnClickOutside from "../../../../shared/hooks/useOnClickOutside";
import {
  StyledDropdownItem,
  StyledExtendedDropdown,
} from "../ThemStyledDropdown.styled";
import { ExtendedDropdownProps } from "../ThemeStyledDropdown.types";
import { MediaAsset } from "@ecp-boxes/boxes/BoxFacetsVariants/BoxFacetsVariants.types";
import { MediaAssetsType } from "@ecp-redux/api/mediaAssets";

const ExtendedDropdown: React.FC<ExtendedDropdownProps> = ({
  dropdown,
  items,
  onClickItem,
  selectedItemId,
  closeDropdown,
  openDropdown,
  searchComponent,
  openOnHover,
  forFacetsVariants,
  width,
}) => {
  const dropdownWrapper = useRef<HTMLDivElement>(null);

  useOnClickOutside(dropdownWrapper, () => {
    closeDropdown();
  });

  const [facetKey, facetValue] =
    Object.entries(forFacetsVariants?.facetObject || {})[0] || [];

  return (
    <StyledExtendedDropdown
      {...(width && { width })}
      settings={dropdown}
      ref={dropdownWrapper}
      className="extended-dropdown"
      onMouseLeave={openOnHover ? closeDropdown : undefined}
      onMouseEnter={openDropdown}
    >
      {searchComponent}
      {items.map((item) => {
        return (
          <StyledDropdownItem
            settings={dropdown}
            className="extended-dropdown__item"
            selectedItem={item.id === selectedItemId}
            disabled={item.disabled ?? false}
            forFacetsVariants={{
              mediaAsset:
                facetValue?.type === MediaAsset.WITH_MEDIA_ASSET
                  ? facetValue.withMediaAssetConfig
                  : undefined,
              mediaAssetData: (forFacetsVariants?.mediaAssetsData &&
                Object.entries(forFacetsVariants?.mediaAssetsData)?.find(
                  ([key, value]) => {
                    if (key === facetKey && facetValue?.withMediaAssetConfig) {
                      return value;
                    }
                  }
                )?.[1]?.values?.[
                  typeof item.id === "string" ? item.id : ""
                ]) ?? { mediaAssetsType: MediaAssetsType.NONE },
            }}
            key={item.id}
          >
            <LinkWrapper
              linkStyle={dropdown.dropdownItemLink}
              fontStyle={dropdown.dropdownItemTypography}
              href=""
              onClick={() => {
                onClickItem(item.id, closeDropdown);
                closeDropdown();
              }}
              className="extended-dropdown__item__label"
              basicColor={
                item?.disabled
                  ? dropdown.dropdownItemDisabledTextColor
                  : undefined
              }
            >
              <>
                {facetValue?.type === MediaAsset.WITH_MEDIA_ASSET && (
                  <div
                    className={"extended-dropdown__item__label__media-asset"}
                  />
                )}
                {typeof item.label === "function"
                  ? item.label(dropdown, item.id === selectedItemId, false)
                  : item?.label}
              </>
            </LinkWrapper>
          </StyledDropdownItem>
        );
      })}
    </StyledExtendedDropdown>
  );
};

export default ExtendedDropdown;
